import { useLazyQuery, useQuery } from "@apollo/client";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  QUERY_AVAILABLE_RADIO_EVENTS,
  QUERY_RADIOS_FOR_EVENT,
  QUERY_PRESIGNED_URL_FOR_RADIO,
} from "../queries/radioQueries";
import {
  setAvailableRadioEvents,
  setActiveEventSessions,
  setActiveURL,
} from "../../../state/radioReducer";

export function QueryAvailableRadioEvents() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_AVAILABLE_RADIO_EVENTS);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setAvailableRadioEvents(data.getAvailableRadioEvents));
    }
  }, [dispatch, data, loading, error]);
}

export function QueryRadiosForEvent() {
  const dispatch = useDispatch();
  const [queryRadiosForEvent, { data, loading, error }] = useLazyQuery(
    QUERY_RADIOS_FOR_EVENT,
  );
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setActiveEventSessions(data.getRadiosForEvent));
    }
  }, [dispatch, data, loading, error]);
  return (event: string) => {
    queryRadiosForEvent({ variables: { event } });
  };
}

export function QueryPresignedURLForRadio() {
  const dispatch = useDispatch();
  const [queryPresignedURL, { data, loading, error }] = useLazyQuery(
    QUERY_PRESIGNED_URL_FOR_RADIO,
  );
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setActiveURL(data.getPresignedURLForRadio));
    }
  }, [dispatch, data, loading, error]);
  return (event: string, session: string, type: string, driver: string) => {
    queryPresignedURL({ variables: { event, session, type, driver } });
  };
}
